<template>
  <div class="big-box">
    <!-- 视频盒子 -->
    <div id="video-box"></div>
  </div>
</template>

<script setup>
// 引入xgplayer插件
import Player, { Events } from "xgplayer";
import "xgplayer/dist/index.min.css";
// 引入vue内置方法
import { onMounted } from "vue";

import { getToken } from "@/utils/utils.js"
import { ElMessage } from "element-plus";
import { useRouter } from "vue-router"

const router = useRouter();

const emits = defineEmits(['videoPlay'])

const props = defineProps({
  // 视频地址
  url: {
    type: String,
    default: "",
  },
  // 视频宽度
  width: {
    type: String,
    default: "343px",
  },
  // 视频高度
  height: {
    type: String,
    default: "201px",
  },
  // 封面地址
  poster: {
    type: String,
    default: "",
  },
  // 是否需要登录才能播放视频
  needLogined:{
    type:Boolean,
    default:false
  }
});

// 初始化函数
function init() {
  // 创建播放器实例对象
  let player = new Player({
    id: "video-box",
    url: props.url,
    width: props.width,
    height: props.height,
    poster: props.poster,
  });
  // 监听播放事件
  player.on(Events.PLAY, () => {
    // console.log("播放");
    // emits('videoPlay')
     // 如果需要登录才能播放视频，那么就去判断是否登录了。如果已登录，那么正常执行后续代码；如果没登录，那么暂停播放、提示消息、跳转到登录页面
    if (props.needLogined) {
      // 已登录
      if(getToken()){
        emits('videoPlay')
      }else{ // 没登录
        // 暂停播放
        player.pause()
        // 提示弹窗
        ElMessage({
          message: "当前用户未登录",
          type: "error",
        });
        // 跳转网址
        router.push({path:"/login/nowLogin"})
      }
    }else{// 不需要登录
      emits('videoPlay')
    }

  });
  // 监听暂停事件
  player.on(Events.PAUSE, () => {
    // console.log("暂停");
  });
  // 监听结束事件
  player.on(Events.ENDED, () => {
    // console.log("结束");
  });
}

onMounted(() => {
  // 调用初始化函数
  init();
});
</script>

<style>
/* 你的样式 */
</style>
